// Draft storage for in-progress text the rep hasn't committed anywhere yet
// (today: Alpha call notes). Mirrors lib/tokens.ts — these two are the only
// sanctioned localStorage modules, so every raw-localStorage read in a
// component is a bug.
//
// INTERIM: notes belong in the cases.notes column; until that lands, drafts
// are PHI sitting in a browser store on a possibly-shared workstation. Two
// mitigations hold the line: every key is namespaced under `mayfirm.draft.`
// so it can be enumerated, and clearDrafts() wipes the whole namespace on
// sign-out.
//
// The typeof guard matches tokens.ts: this module can be imported in code
// paths that may run without a DOM.

const PREFIX = "mayfirm.draft.";

/** Pre-namespace Alpha note keys (`alpha:notes:<id>`), swept by
 *  clearDrafts so demo browsers don't keep PHI the new store can't see. */
const LEGACY_NOTES_PREFIX = "alpha:notes:";

function draftKey(kind: string, id: string): string {
  return `${PREFIX}${kind}.${id}`;
}

/** Key for one matter's call notes. Callers pass this to getDraft/setDraft. */
export function caseNotesKey(caseId: string): string {
  return draftKey("case-notes", caseId);
}

export function getDraft(key: string): string | null {
  if (typeof localStorage === "undefined") return null;
  return localStorage.getItem(key);
}

export function setDraft(key: string, value: string): void {
  if (typeof localStorage === "undefined") return;
  localStorage.setItem(key, value);
}

export function removeDraft(key: string): void {
  if (typeof localStorage === "undefined") return;
  localStorage.removeItem(key);
}

/** Wipes every draft this app has written. Called alongside clearTokens()
 *  on sign-out — a rep signing off a shared machine leaves no notes behind. */
export function clearDrafts(): void {
  if (typeof localStorage === "undefined") return;
  const doomed: string[] = [];
  for (let i = 0; i < localStorage.length; i += 1) {
    const key = localStorage.key(i);
    if (key === null) continue;
    if (key.startsWith(PREFIX) || key.startsWith(LEGACY_NOTES_PREFIX)) {
      doomed.push(key);
    }
  }
  // Collected first: removing during the walk shifts the index.
  for (const key of doomed) {
    localStorage.removeItem(key);
  }
}
